export default "__VITE_ASSET__Cx4jN64p__"